module.exports = __webpack_public_path__ + "static/Bundle3_VinylAll-e5c03b69d630673b5536c0c0affa7ccf.png";